import Vue from 'vue'
import { getLanguage } from '@/utils/auth'
import {language} from '../assets/language'
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
const i18n = new VueI18n(
    {
        silentTranslationWarn: true,
        locale: getLanguage()||'zh',
        messages: {...(language => {
                const [zh, en] = [{}, {}];
                (function translation(o, p = []) {
                    Object.entries(o).forEach(([k, v]) =>
                        Array.isArray(v) ? p.concat(k).reduce((a, c, i, arr) =>
                                a[c] = i === arr.length-1 ? v[0] : (a[c] || {}), zh) &&
                            p.concat(k).reduce((a, c, i, arr) =>
                                a[c] = i === arr.length-1 ? v[1] : (a[c] || {}), en)
                            : translation(v, [...p, k]));
                })(language);
                return { zh, en };
            })(language)}
    }
)
export default i18n
